import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import dispatcherAddUserPermissionDefinition from "./dispatcher-add-user-permission";

const useCargoOfficerAddUserPermissions = () => {
  return useUserPermissions(dispatcherAddUserPermissionDefinition);
};

export default useCargoOfficerAddUserPermissions;
